import { useRouter } from 'next/router'
import sortedUniqBy from 'lodash/sortedUniqBy'
import sortBy from 'lodash/sortBy'
import { toggle } from 'utils'
import { useEffect, useState } from 'react'
import { sendProductImpressionGTM } from '../utils/gtm'

export default function useCatalogo(items, setItems, setGtmSent) {
  const router = useRouter()

  const [selected, setSelected] = useState(router.query.filtri?.split('/').map(Number) || [])
  const [novita, setNovita] = useState('novita' in router.query || false)
  const [usedFilter, setUsedFilter] = useState(false)

  useEffect(() => {
    if (router.query?.filtri) {
      changeFiltri(router.query.filtri)
    } else {
      filter([], novita)
    }
  }, [router.query?.filtri])

  useEffect(() => {
    if ('novita' in router.query) {
      setNovita(true)
    }
  }, [router.query?.novita])

  useEffect(() => {
    filter(selected, novita)
  }, [selected, novita])

  function filter(selected, novita) {
    let filteredItems = []

    if (selected.length) {
      const filters = getSelectedFilters()
      const grouped = groupByAttributo(filters)

      filteredItems = items.filter(item => {
        let checks = []

        Object.entries(grouped).forEach(([key, value]) => {
          const attributo = item.tassonomia.find(a => a.id === Number(key))
          if (attributo) {
            const valori = attributo.valori_attributi.map(v => v.id)
            checks.push(value.some(s => valori.includes(s)))
          } else {
            checks.push(false) // attributo non trovato
          }
        })

        return checks.length ? checks.every(Boolean) : false
      })
    } else {
      filteredItems = items
    }

    if (filteredItems.length && novita && 'novita' in filteredItems[0]) {
      filteredItems = filteredItems.filter(item => item.novita) // nuova produzione
    }
    if (selected.length > 0) {
      sendProductImpressionGTM(filteredItems, 'navigazione_standard')
      setUsedFilter(true)
    }
    if (selected.length == 0 && usedFilter) {
      setGtmSent(false)
    }
    setItems([...filteredItems])
  }

  function toggleFilter(item) {
    let tmp = selected
    toggle(tmp, item.id)

    const baseUrl = router.asPath.split('?')[0]

    const filtri = tmp.length ? `?filtri=${tmp.join('/')}` : ''
    const nuovaProduzione = novita ? (filtri ? `&novita` : '?novita') : ''
    const url = `${baseUrl}${filtri}${nuovaProduzione}`
    router.push(url, undefined, { shallow: true, scroll: false }) // client side transition
  }

  function changeFiltri(filtri) {
    setSelected(filtri?.split('/').map(Number))
  }

  function getAttributi(attributi) {
    return attributi.map(item => ({ ...item, url: null, selected: selected.includes(item.id) }))
  }

  function getFilterVisibility(attributi) {
    return attributi.some(a => selected.includes(a.id))
  }

  function getUniqueFilters(chiave, prefix) {
    return sortedUniqBy(
      sortBy(
        items
          .map(item => item.tassonomia)
          .flat()
          .filter(a => a.chiave === chiave)
          .map(a => a.valori_attributi)
          .flat()
          .map(v => ({ ...v, nome: `${prefix}${v.nome}` })), // per prefisso 'Classe '
        ['nome']
      ),
      'id'
    ).slice(0, 7)
  }

  function getSelectedFilters() {
    return sortedUniqBy(
      sortBy(
        items
          .map(item => item.tassonomia)
          .flat()
          .map(a => a.valori_attributi)
          .flat()
          .filter(v => selected.includes(v.id)),
        ['nome']
      ),
      'id'
    ).slice(0, 7)
  }

  function groupByAttributo(valori) {
    let attributi = {}

    valori.forEach(v => {
      attributi[v.attributo] ? attributi[v.attributo].push(v.id) : (attributi[v.attributo] = [v.id])
    })

    return attributi
  }

  return {
    toggleFilter,
    getAttributi,
    getFilterVisibility,
    getUniqueFilters,
  }
}
